import { Injectable, inject } from '@angular/core';
import { MortgageApiService } from '@api-new/mortgageservice';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { getLenders, getLendersFailure, getLendersSuccess } from './lenders.action';

@Injectable()
export class LendersEffects {
  private readonly mortgageApiService = inject(MortgageApiService);
  private readonly actions$ = inject(Actions);

  getLenders = createEffect(() =>
    this.actions$.pipe(
      ofType(getLenders),
      switchMap(() => this.mortgageApiService.HTTP_X_ListLenders(null)),
      map((lenders) => getLendersSuccess(lenders)),
      catchError((error) => of(getLendersFailure({ error }))),
    ),
  );
}
